import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { RenderLearningMethod } from "../../../../../utils/CommonGroupingItem";
import { TABLE_DATE_FORMAT, TABLE_ROWS_PER_PAGE } from "../../../../../utils/Constants";
import PermissionsGate from "../../../../../utils/permissionGate";
import { Link } from "react-router-dom";
import $ from "jquery";
import { handleTableScroll } from "../../../../../utils/commonFunction";

const CoursesTable = (props) => {
  const [courses, setCourses] = useState({});
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  
  useEffect(() => {
    handleTableScroll()
  }, [props])
  
  useEffect(() => {
    setCourses(props && props.courses ? props.courses : {});
  }, [props]);
  
  const handleChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  
  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  };
  
  const handleClose = () => {
    $("#viewCourses").modal("hide");
    $("#viewAvailCourses").modal("hide");
    $(".modal-backdrop.show").removeClass('show');
  }
  function showCourses() {
    $("#viewAllCourses").modal("show");
  }
  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "course_name",
      sortable: true,
      cell: (row) =>
        row.course_name ? (
        <Link className="as-text-blue overflow-ellipsis2" onClick={() => handleClose()} title={row.course_name} to={`/courseAdministration/coursesdetails/${row.intake_id}/detailCourses/show`}>
        {row.course_name}
        </Link>
      ) : (
        "-"
      ),
    },
    {
      name: "Start",
      selector: "start",
      sortable: true,
      cell: (row) => (
        <>
        {row.start ? (
          <div className="dateTime">
          <p className="right-space">{moment.unix(row.start).format(TABLE_DATE_FORMAT)}</p>
          </div>
        ) : (
          "-"
        )}
        </>
      ),
    },
    {
      name: "End",
      selector: "end",
      sortable: true,
      cell: (row) => (
        <>
        {row.end ? (
          <div className="dateTime">
          <p className="right-space">{moment.unix(row.end).format(TABLE_DATE_FORMAT)}</p>
          </div>
        ) : (
          "-"
        )}
        </>
      ),
    },
    {
      name: "Intake",
      selector: "year",
      sortable: true,
      cell: (row) => <>{row.year ? row.year + "-" + row.number : "-"}</>,
    },
    {
      name: "Learning Method",
      selector: "type",
      sortable: true,
      cell: (row) => row.type ? RenderLearningMethod(row.type).html : "-",
    },
  ]);
  
  
  if(props.isRemoveBtn){
    // columns.push({
    //   name: "Exemption",
    //   selector: "type2",
    //   sortable: true,
    //   cell: (row) => (<p>{row.grant_exemption}</p>),
    // });
    columns.push({
      name: "Exemption",
      selector: "exemption",
      sortable: true,
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
        <div className="as-buttons">
        {Number(row.grant_exemption) === 1 ? (
          <PermissionsGate
          scopes={["studentgge"]}
          errorProps={{ disabled: true }}
          >
          <button
          className="btn btn-success rounded-circle"
          title="Exempted – click to remove from exemption"
          onClick={() => props.grantExemption(row.intake_id, 0)}
          >
          <i className="fal fa-user-plus"></i>
          </button>
          </PermissionsGate>
        ) : (
          <PermissionsGate
          scopes={["studentgge"]}
          errorProps={{ disabled: true }}
          >
          <button
          className="btn btn-danger rounded-circle"
          title="Not exempted – click to grant exemption"
          onClick={() => props.grantExemption(row.intake_id, 1)}
          >
          <i className="fal fa-user-times"></i>
          </button>
          </PermissionsGate>
        )}
        </div>
        </div>
      )
    })
  }
  function addIds(isRemove = false) {
    let obj = { ...courses };
    obj.sub_item = selectedRows;
    if (!isRemove) {
      props.assignCourse(obj);
    } else {
      const arr1 = courses.sub_item;
      const arr2 = selectedRows;
      function getDifference(array1, array2) {
        return array1.filter((object1) => {
          return !array2.some((object2) => {
            return object1.intake_id === object2.intake_id;
          });
        });
      }
      obj.sub_item = getDifference(arr1, arr2);
      props.removeCourse(obj);
    }
    handleClearRows();
  }
  
  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="custom-table-div filter-search-icon card-table-custom c-a-p-c-t">
    <DataTable
    data={courses.sub_item}
    defaultSortField="start"
    defaultSortAsc={true}
    columns={columns}
    pagination={true}
    selectableRows
    onSelectedRowsChange={handleChange}
    clearSelectedRows={toggledClearRows}
    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
    />
    {/* {courses && courses.sub_item && courses.sub_item.length > 0 && ( */}
    <div className="btn-sec">
    {!props.isRemoveBtn && (
      <PermissionsGate errorProps={{ disabled: true }} scopes={["scpadd"]}>
      <button
      className="btn btn-primary"
      type="button"
      title="Add"
      onClick={() => {
        addIds();
      }}
      >
      <i className="fal fa-plus"></i>Add
      </button>
      </PermissionsGate>
    )}
    {props.isRemoveBtn && (<>
      {(courses && courses.sub_item && courses.sub_item.length > 0) && <PermissionsGate errorProps={{ disabled: true }} scopes={["scpadd"]}>
      <button
      title="Remove"
      className="btn btn-danger"
      onClick={() => {
        addIds(true);
      }}
      >
      <i className="fal fa-trash-alt"></i>Remove
      </button>
      </PermissionsGate>}
      <button
      title="Add Course"
      className="btn btn-danger ml-2"
      onClick={() => {
        showCourses(true);
        props.getAllCourses()
      }}
      >
      <i className="fal fa-plus"></i>Add Course
      </button>
      </>
    )}
    </div>
    {/* )} */}
    </div>
    </div>
  );
};

export default CoursesTable;
